import { render, staticRenderFns } from "./MapitDialog.vue?vue&type=template&id=05f97804"
import script from "./MapitDialog.vue?vue&type=script&lang=ts"
export * from "./MapitDialog.vue?vue&type=script&lang=ts"
import style0 from "./MapitDialog.vue?vue&type=style&index=0&id=05f97804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports